import { render, staticRenderFns } from "./customerLocationByCategoryAndSegment.vue?vue&type=template&id=608d88ec"
import script from "./customerLocationByCategoryAndSegment.vue?vue&type=script&lang=js"
export * from "./customerLocationByCategoryAndSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports